import type { JSX } from 'preact';
import {
  CircleDashed,
  CircleDot,
  Eraser,
  Flag,
  Hand,
  Hexagon,
  Layers,
  Magnet,
  MousePointer2,
  Mountain,
  Play,
  RotateCw,
  Scaling,
  Trees,
  Redo2,
  CopyPlus,
  Route,
  Spline,
  Trash2,
  Undo2,
  Waves,
  type LucideIcon,
} from 'lucide-preact';
import type { EditorTool } from '../../sim/map/index.ts';

export const EDITOR_ICON_SIZE = 18;
export const EDITOR_ICON_STROKE = 1.75;

export function EditorIcon({ icon: Icon }: { icon: LucideIcon }): JSX.Element {
  return <Icon size={EDITOR_ICON_SIZE} strokeWidth={EDITOR_ICON_STROKE} aria-hidden="true" />;
}

export const TOOL_ICONS: Record<EditorTool, LucideIcon> = {
  select: MousePointer2,
  hand: Hand,
  scale: Scaling,
  rotate: RotateCw,
  'draw-island': Mountain,
  'draw-rock': Hexagon,
  'draw-terrace': Layers,
  'draw-water': Waves,
  'place-checkpoint': Flag,
  'edit-start-area': CircleDashed,
  'edit-park-area': CircleDot,
  'draw-route': Route,
  'place-prop': Trees,
  'erase-prop': Eraser,
};

export const MagnetIcon = Magnet;
export const PlayIcon = Play;
export const RedoIcon = Redo2;
export const UndoIcon = Undo2;
export const CopyPlusIcon = CopyPlus;
export const TrashIcon = Trash2;
export const StraightenIcon = Spline;
